import { Input, Spin } from "antd";
import React, { useState } from "react";

import ClientList from "./ClientList";
import PropTypes from "prop-types";
import axios from "../../utils/axios";
import { getNoCache } from "../../utils/noCache";
import { useEffect } from "react";

function RemoteClients({ search, onSearchChange }) {
  /* ---------------------------------- Hooks --------------------------------- */

  const [data, setData] = useState([]);
  const [vpn, setVpn] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const getData = React.useCallback(async () => {
    const res = await getNoCache(axios, "/clients.json");
    // Defensif : si clients.json est absent (ex. non deploye), l'appel peut
    // renvoyer autre chose qu'un objet de clients -> ne pas planter le composant.
    const raw = res && res.data;
    const items = raw && typeof raw === "object" ? Object.values(raw) : [];
    setData(
      items
        .filter((c) => c && typeof c.name === "string")
        .sort((a, b) => a.name.localeCompare(b.name))
    );
    setLoaded(true); // 1er chargement des clients termine (plus de Spin si vide)
  }, []);

  const getVpnData = React.useCallback(async () => {
    const res2 = await getNoCache(axios, "/api/vpn");
    // Defensif : si l'endpoint /api/vpn est indisponible (ou reponse vide),
    // ne pas planter -> liste VPN vide.
    const body = res2 && res2.data;
    let tmpData = (Array.isArray(body) ? body : []).filter((con) => con && typeof con.container === "string");
    setVpn(tmpData);
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    getVpnData();
    const interval = setInterval(() => {
      getVpnData();
    }, 10000);
    return () => clearInterval(interval);
  }, [getVpnData]);

  const getActiveVpn = (_group) => {
    const sVpn = vpn.find((sVpn) => {
      return sVpn.container === _group.vpn_container_name;
    });
    return sVpn && sVpn.state === "running";
  };

  /* --------------------------------- Render --------------------------------- */
  return (
    <>
      <div className="vpn-header">
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Recherche"
        />
      </div>
      {loaded ? (
        data.map((group) => {
          if (group.name !== "Elsan") {
            return (
              <div className="rds-data" key={group.name}>
                <ClientList
                  data={group}
                  vpnActive={getActiveVpn(group)}
                  search={search}
                />
              </div>
            );
          } else {
            return null;
          }
        })
      ) : (
        <Spin
          style={{
            width: "100%",
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      )}
    </>
  );
}

RemoteClients.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default RemoteClients;
